import React, { useCallback } from 'react'
import { BtnV2, l } from '@manychat/manyui'

import { useAppSelector } from 'reduxTyped'
import { billing } from 'common/billing/billingService/billingService'
import { calculateAnnualSavings } from 'common/billing/components/ForcedMigration/utils'
import {
  getMigrationData,
  isActiveProMigration,
} from 'common/billing/entities/billingVersions/selectors'
import { getCurrency } from 'common/billing/entities/pro/utils/convertPrice'
import { useCurrentSubscription } from 'common/billing/hooks/useCurrentSubscription'
import { UpgradeSource } from 'common/billing/interfaces/upgradeSource'
import { useDidMountEffect } from 'utils/commonHooks'
import { analyticsService } from 'utils/services/analytics'

export const ForcedNpmMigrationNotification = () => {
  const migrationData = useAppSelector(getMigrationData)
  const activeMigration = isActiveProMigration(migrationData) ? migrationData.data : null
  const currency = getCurrency()

  const currentSubscription = useCurrentSubscription()
  const { total } = currentSubscription || { total: { amount: 0, currency } }

  useDidMountEffect(() => {
    analyticsService.sendEvent('NOTIFICATION_BAR.FORCED_NPM_MIGRATION.SHOWN')
  })

  const handleSeeChangesClick = useCallback(() => {
    analyticsService.sendEvent('NOTIFICATION_BAR.FORCED_NPM_MIGRATION.SEE_CHANGES.CLICKED')
    billing.requestUpgrade({
      source: UpgradeSource.FORCED_NPM_MIGRATION_NOTIFICATION,
    })
  }, [])

  const getAnnualSavings = useCallback(() => {
    const targetPlan = activeMigration?.targetPlan
    const targetProduct = targetPlan ? activeMigration?.products[targetPlan] : undefined

    return calculateAnnualSavings({
      currentPlanPrice: total?.amount || 0,
      targetPlanPrice: targetProduct?.price?.amount || 0,
      targetPlanPeriod: targetProduct?.price?.period,
      currency: total?.currency || currency,
    })
  }, [total?.amount, total?.currency, currency, activeMigration])

  const annualSavings = getAnnualSavings()

  return (
    <>
      <span>
        {annualSavings.amount > 0
          ? l.translate('Good news: your new plan could cost less.')
          : l.translate('Good news: the new plans come with more.')}
      </span>
      <BtnV2 variant="success" onClick={handleSeeChangesClick} className="m-l-sm">
        {l.translate('Show me')}
      </BtnV2>
    </>
  )
}
